export function getAll(): Record<string, string> {
	return Object.fromEntries(
		document.cookie
			.split(';')
			.map(entry => entry.trim().split('='))
			.filter(([key]) => !!key)
		)
}

export function get(key: string): string | null {
	return getAll()[key]
}

export function set(name: string, value: string, days: number = 30) {
	const entry = [
		`${name}=${value}`,
		days && 'Expires=' + new Date(Date.now() + 1000 * 60 * 60 * 24 * days).toUTCString(),
	].filter(c => c)

	document.cookie = entry.join('; ')
}

export function clear(key: string) {
	set(key, '', 0)	
}